import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Canvas } from '../components/Canvas';
import { Frame } from '../components/Frame';
import { LiveIndicatorWithCount } from '../components/LiveIndicator';
import { CenteredContentContainer } from '../components/layout/content/CenteredContentContainer';
import { HeaderWithLeftLogoAndControls } from '../components/layout/headers/HeaderWithLeftLogoAndControls';
import { PageLayout } from '../components/layout/PageLayout';
import { RecordingsList } from '../components/RecordingsList';
import { BottomLeftSlot, HudSlots, TopLeftSlot, } from '../components/shared/HudSlots';
import { VideoDisplay } from '../components/VideoDisplay';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { RecordingService } from '../services/recording/RecordingService';
import { ViewerService } from '../services/viewer/ViewerService';
import { formBroadcastPath } from '../utils/url';
export const RecordingsListPage = () => {
    const activeBroadcast = BroadcastStateService.getOutput().useActiveBroadcast();
    const isVideoStreaming = ViewerService.getOutput().useIsVideoStreaming();
    const isMuted = ViewerService.getOutput().useAudioMuted();
    const recordingService = RecordingService.getNotificationInterface();
    const viewerService = ViewerService.getNotificationInterface();
    const recordingsList = RecordingService.getOutput().useRecordingsList();
    const handleCanvasMount = useCallback((canvas) => {
        if (canvas) {
            viewerService.notifyCanvasMounted(canvas);
        }
    }, [viewerService]);
    useEffect(() => {
        if (activeBroadcast) {
            recordingService.notifyFetchRecordingsList(activeBroadcast.broadcasterUserId, activeBroadcast.streamId, activeBroadcast.myRole === 'broadcaster');
        }
        return () => {
            recordingService.notifyResetRecordingsList();
        };
    }, [activeBroadcast, recordingService]);
    useEffect(() => {
        if (!isMuted) {
            ViewerService.getNotificationInterface().notifyMuteToggle();
        }
    }, [isMuted]);
    return (_jsx(PageLayout, { header: _jsx(HeaderWithLeftLogoAndControls, {}), children: _jsxs(CenteredContentContainer, { children: [_jsx(CanvasWrap, { "$isVisible": isVideoStreaming, href: activeBroadcast
                        ? formBroadcastPath(activeBroadcast)
                        : undefined, children: _jsx(CanvasContainer, { children: activeBroadcast && (_jsx(VideoDisplay, { component: _jsx(Canvas, { onCanvasMount: handleCanvasMount }), hud: _jsxs(HudSlots, { children: [_jsx(TopLeftSlot, { children: _jsx(LiveIndicatorWithCount, {}) }), _jsx(BottomLeftSlot, { children: _jsx(BroadcastTitle, { children: activeBroadcast.name }) })] }) })) }) }), _jsx(RecordingsListFrameRoot, { children: _jsxs(RecordingsListFrame, { children: [_jsx(RecordingsHeader, { children: _jsxs("span", { children: [activeBroadcast?.name, " recordings"] }) }), recordingsList && (_jsx(RecordingsList, { recordings: recordingsList.recordings, variant: "broadcaster", hasMore: recordingsList.hasMore, status: recordingsList.status, onLoadMore: () => {
                                    recordingService.notifyFetchMoreRecordings();
                                } }))] }) })] }) }));
};
const RecordingsListFrameRoot = styled.div `
    margin: 0 auto;
    max-width: 100%;
    padding: 0 1.75rem;
    width: var(--BroadcastFrame_Width, 90vw);
    box-sizing: border-box;

    @media (min-width: 80rem) {
        --BroadcastFrame_Width: 70vw;
    }
`;
const RecordingsListFrame = styled(Frame) `
    color: #ffffff;
    margin: 0 auto;
    min-width: 0;
    padding: 2rem;
    --tv-ui-shiny-border-radius: 2rem;
`;
const RecordingsHeader = styled.div `
    margin-bottom: 1rem;
    font-size: 1.35rem;
    font-weight: 500;
    width: 100%;
    text-align: left;
`;
const CanvasWrap = styled.a `
    padding: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 1rem;
    display: none;
    ${({ $isVisible }) => $isVisible && css `display: block;`}
    text-decoration: none;
    color: var(--tv-ui-color-3);

    &:hover, &:focus, &:active, &:visited {
        color: var(--tv-ui-color-3);
    }
`;
const CanvasContainer = styled.div `
    width: 100%;
    aspect-ratio: 16/9;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 2rem;
    position: relative;
`;
const BroadcastTitle = styled.span `
    font-size: 1.35rem;
    font-weight: 500;
`;
